"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardTdcBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_card_tdc_constants_1 = require("./bc-card-tdc-constants");
var helpers_1 = require("../../../common/helpers");
var BcCardTdcBehavior = (function (_super) {
    __extends(BcCardTdcBehavior, _super);
    function BcCardTdcBehavior() {
        return _super.call(this) || this;
    }
    BcCardTdcBehavior.setUpAll = function () {
        var tdcCardElements = Array.from(document.querySelectorAll("[class~='".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC, "']")));
        var elements = [];
        for (var _i = 0, tdcCardElements_1 = tdcCardElements; _i < tdcCardElements_1.length; _i++) {
            var cardTdcElement = tdcCardElements_1[_i];
            var bcCardTdcBehavior = new BcCardTdcBehavior();
            bcCardTdcBehavior.setElement(cardTdcElement);
            bcCardTdcBehavior.setUp();
            elements.push(bcCardTdcBehavior);
        }
        return elements;
    };
    BcCardTdcBehavior.prototype._setUp = function () {
        this.detectCheckable();
        this.initListeners();
        this.addAccessibility();
    };
    BcCardTdcBehavior.prototype.initListeners = function () {
        var _this = this;
        this.mySelf.addEventListener('click', function () { return _this.selectCard(); });
        this.selectableRef.addEventListener('click', function (ev) { return ev.preventDefault(); });
    };
    BcCardTdcBehavior.prototype.detectCheckable = function () {
        var isChekbox = this.mySelf.querySelector("input[type=checkbox]");
        var isRadio = this.mySelf.querySelector("input[type=radio]");
        if (isChekbox || isRadio) {
            this.selectableRef = (isChekbox || isRadio);
            this.type = isChekbox ? 'checkbox' : 'radioButton';
        }
    };
    BcCardTdcBehavior.prototype.selectCard = function () {
        if (this.selectableRef) {
            var currentCard = this.mySelf.querySelector(".".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC)) || this.mySelf;
            switch (this.type) {
                case 'checkbox':
                    var checked = this.selectableRef.checked;
                    this.selectableRef.checked = !checked;
                    currentCard.classList[this.isSelected ? 'add' : 'remove'](bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC_SELECTED);
                    break;
                case 'radioButton':
                    var radioGroup = document.getElementById(this.radioGroupName);
                    (radioGroup || document).querySelectorAll(".".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC, " input[type=radio]")).forEach(function (cardTdcRadio) {
                        cardTdcRadio.checked = false;
                        cardTdcRadio.closest(".bc-card-tdc").classList.remove(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC_SELECTED);
                    });
                    this.selectableRef.checked = true;
                    currentCard.classList[this.isSelected ? 'add' : 'remove'](bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC_SELECTED);
                    break;
                default:
                    break;
            }
        }
    };
    Object.defineProperty(BcCardTdcBehavior.prototype, "isSelected", {
        get: function () {
            return this.selectableRef.checked;
        },
        enumerable: false,
        configurable: true
    });
    BcCardTdcBehavior.prototype.addAccessibility = function () {
        var _this = this;
        (0, helpers_1.addFocusable)(this.mySelf.querySelector(".".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC)) || this.mySelf, { tabindex: '0' }, { event: function () { return _this.selectCard(); } });
        this.addIconAccessibility();
        this.addHeaderAccessibility();
        this.addMinimumPaymentAccessibility();
        this.addDueDateAccessibility();
    };
    BcCardTdcBehavior.prototype.addDueDateAccessibility = function () {
        var dueDateElement = Array.from(this.mySelf.querySelectorAll(".".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC_DUE_DATE)));
        for (var _i = 0, dueDateElement_1 = dueDateElement; _i < dueDateElement_1.length; _i++) {
            var content = dueDateElement_1[_i];
            (0, helpers_1.addFocusable)(content, { tabindex: '-1' });
        }
    };
    BcCardTdcBehavior.prototype.addMinimumPaymentAccessibility = function () {
        var minimumPaymentElement = Array.from(this.mySelf.querySelectorAll(".".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC_MINIMUM_PAYMENT)));
        for (var _i = 0, minimumPaymentElement_1 = minimumPaymentElement; _i < minimumPaymentElement_1.length; _i++) {
            var content = minimumPaymentElement_1[_i];
            (0, helpers_1.addFocusable)(content, { tabindex: '-1' });
        }
    };
    BcCardTdcBehavior.prototype.addIconAccessibility = function () {
        var iconElement = Array.from(this.mySelf.querySelectorAll(".".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC, " .bc-icon")));
        for (var _i = 0, iconElement_1 = iconElement; _i < iconElement_1.length; _i++) {
            var content = iconElement_1[_i];
            (0, helpers_1.addFocusable)(content, { tabindex: '-1' });
        }
    };
    BcCardTdcBehavior.prototype.addHeaderAccessibility = function () {
        var headerElement = Array.from(this.mySelf.querySelectorAll(".".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC_HEADER)));
        for (var _i = 0, headerElement_1 = headerElement; _i < headerElement_1.length; _i++) {
            var content = headerElement_1[_i];
            (0, helpers_1.addFocusable)(content, { tabindex: '-1' });
        }
        var titleElement = Array.from(this.mySelf.querySelectorAll(".".concat(bc_card_tdc_constants_1.BcCardTdcConstants.CARD_TDC_TITLE)));
        titleElement === null || titleElement === void 0 ? void 0 : titleElement.forEach(function (item) {
            if (item.innerHTML.length > 0) {
                var ariaLabel = "Tarjeta ".concat(item.innerHTML);
                item.setAttribute('aria-label', ariaLabel);
            }
        });
    };
    return BcCardTdcBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCardTdcBehavior = BcCardTdcBehavior;
